import { table } from './_table';

export const detailed = {
  namespaced: true,
  modules: {
    table
  }
};
